module.exports = __webpack_public_path__ + "img/785eec7.png";